module.exports = __webpack_public_path__ + "static/assets/01fabf98aaec52afaabf089b2683c645.svg";